import React from 'react';
import styled from 'styled-components';
import media from 'src/styles/media';
import { t } from 'src/utils/translate';

import Container from 'components/Container';
import ContentBlock from 'components/ContentBlock';
import ButtonLink from 'components/ButtonLink';
import List from './elements/List';

const Accordion = () => {
  return (
    <Container>
      <Root>
        <ColumnLeft>
          <ContentBlock
            title={t('interiors.featuresFinishes')}
          >
            <ButtonLink href="/ivy-feature-sheet.pdf" target="_blank">{t('interiors.downloadBtn')}</ButtonLink>
          </ContentBlock>
        </ColumnLeft>
        <ColumnRight>
          <List />
        </ColumnRight>
      </Root>
    </Container>
  );
};

const Root = styled.div`
  display: flex;
  padding-top: 70px;
  padding-bottom: 70px;
  justify-content: flex-start;
  @media (max-width: ${media.md}) {
    flex-wrap: wrap;
  }
`;

const ColumnLeft = styled.div`
  width: 27.5%;
  @media (max-width: ${media.md}) {
    width: 100%;
    padding-bottom: 50px;
  }
`;

const ColumnRight = styled.div`
  width: 60%;
  @media (max-width: ${media.md}) {
    width: 100%;
  }
`;

export default Accordion;



// WEBPACK FOOTER //
// ./src/pages/Interiors/elements/Accordion/Accordion.js